import React from 'react'
import { useFormContext } from 'react-hook-form'
import { mixinInputFormClasses } from 'spa/member/styles/mixin'
import { FormErrorMessage } from 'spa/member/components/FormErrorMessage'

export type Props = {
  inputSize?: 'default' | 'small'
  rules?: any
} & React.TextareaHTMLAttributes<HTMLTextAreaElement>

const textareaStyle = {
  minHeight: '140px'
}

export const StyledTextArea: React.FC<Props> = (props: Props) => {
  const { register, formState: { errors } } = useFormContext()

  const hasError = !!errors[props.name]

  const baseClassName = 'appearance-none bg-member-white-100 text-member-black-100 leading-normal'
  const mixinClassName = mixinInputFormClasses(hasError, props.inputSize)
  const className = [baseClassName, props.className || '', mixinClassName].filter(Boolean).join(' ')

  return(
    <>
      <textarea
        {...Object.fromEntries(Object.entries(props).filter(([key, _value]) => !['rules', 'inputSize'].includes(key)))}
        {...register(props.name, props.rules)}
        className={className}
        style={textareaStyle} />
      {hasError && <FormErrorMessage message={String(errors[props.name]?.message)} />}
    </>
  )
}
